import { useState, useEffect } from 'react';
import {
  Dialog,
  Checkbox,
  Typography,
  PrimaryButton,
} from '@uni-of-exeter/digital.lib.react.ui.kit';

import './cookies-dialog.css';
import { APP_TEXT } from '../../const/app-text';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: (v: boolean) => void;
  loading: boolean;
}

export const CookiesDialog: React.FC<DialogProps> = ({ isOpen, onClose, onAccept, loading }) => {
  const [acceptAnalytics, setAcceptAnalytics] = useState(false);

  useEffect(() => {
    if (isOpen === true) {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = 'blur(4px)';
    } else {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = '';
    }
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      closable={false}
      maxWidth="sm"
      className="cookies-dialog"
      footer={
        <div className="cookies-dialog-footer">
          <PrimaryButton
            aria-label={APP_TEXT.components.cookiesDialog.continueButton}
            aria-hidden={!isOpen}
            label={APP_TEXT.components.cookiesDialog.continueButton}
            onClick={() => onAccept(acceptAnalytics)}
            className="cookies-continue-button"
            loading={loading}
          />
        </div>
      }
    >
      <div className="cookies-dialog-content">
        <Typography
          variant="h4"
          fontWeight={700}
          className="cookies-dialog-title"
        >
          {APP_TEXT.components.cookiesDialog.title}
        </Typography>

        <Typography
          variant="body.small"
          className="cookies-dialog-description"
        >
          {APP_TEXT.components.cookiesDialog.description}{' '}
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="cookies-terms-link"
          >
            {APP_TEXT.components.cookiesDialog.termsLink}
          </a>
          .
        </Typography>
        <div className="cookies-checkbox-container">
          <div className="cookies-checkbox-label">
            <Checkbox
              checked={acceptAnalytics}
              onChange={() => setAcceptAnalytics(!acceptAnalytics)}
            />
            <label
              className="cookies-checkbox-text"
              onClick={() => setAcceptAnalytics(!acceptAnalytics)}
            >
              {APP_TEXT.components.cookiesDialog.checkboxLabel}
            </label>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
